import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { Checkbox, TextInput } from '@dbk/ui-forms';
import Button from '@dbk/ui-buttons';
import WizardSteps from '@dbk/ui-wizard-steps';
import { List, ListItem } from '@dbk/ui-list';
import Spinner from '@dbk/ui-spinner';
import DocUploadWizardView from '../common/doc-upload-wizard-view/doc-upload-wizard-view';
import DocUploadSearch from '../doc-upload-search';
import DocUploadForm from '../doc-upload-form';
import DocUploadCondition from '../doc-upload-conditions';
import DocUploadFinalize from '../doc-upload-finalize';

class UploadDocument extends PureComponent {
  constructor(props) {
    super(props);
  }

  state = {
    bpsearch: '',
    isCheckboxSelected: '',
    isTableVisible: false,
    selectedOptions: [],
    bpList: '',
  }

  componentWillUnmount() {
    console.log(this.state);
    console.log("unmounting");
  }


  wizardView = (index) => {

    switch (index) {
      case 0: return <DocUploadSearch />;
      case 1: return <DocUploadForm />;
      case 2: return <DocUploadCondition />;
      case 3: return <DocUploadFinalize />;
      default: return <DocUploadSearch />;
    }

  }

  render() {
    const { i18n: { messages }, docupload: { docUploadWizardIndex, contractDetails, search: { showSpinner } } } = this.props;
    return (
      <div className="columns large-9 large-centered">
        <DocUploadWizardView messages={messages} type={docUploadWizardIndex} />
        <div className="row">
          {this.wizardView(docUploadWizardIndex)}
        </div>
      </div>

    )
  }

}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    changePage: { $call: 'ui.history.push' },
    docupload: {
      fetchContractsForBp: { $call: 'fetchContractsForBp' },
      contractDetails: true,
      docUploadWizardIndex: true,
      search: { showSpinner: true }
    },
  },
})(UploadDocument);
